exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width:960px){a.HelpMeChoose_HelpMeChoose__2eI1l.HelpMeChoose_HelpMeChooseBtn__2L1Mh.HelpMeChoose_HelpMeChoosePrimary__2fj-y{margin-bottom:10px;font-size:16px;line-height:23px;font-weight:400;margin-bottom:0;font-weight:700;padding-top:8px;padding-bottom:9px}}", ""]);

// exports
exports.locals = {
	"greenLight": "#79ff88",
	"greenMain": "#3dcd58",
	"greenDark": "#009530",
	"blueLight": "#7fe6ff",
	"blueMain": "#42b4e6",
	"blueDark": "#0084b4",
	"errorLight": "#ff5a36",
	"errorMain": "#b10043",
	"errorDark": "#c20000",
	"textBlack": "#333",
	"textGray": "#9b9b9b",
	"textWhite": "#fff",
	"grayLight": "#9fa0a4",
	"grayBorder": "#e7e6e6",
	"HelpMeChoose": "HelpMeChoose_HelpMeChoose__2eI1l",
	"HelpMeChooseBtn": "HelpMeChoose_HelpMeChooseBtn__2L1Mh",
	"HelpMeChoosePrimary": "HelpMeChoose_HelpMeChoosePrimary__2fj-y"
};